<div class="trip-type-tabs-container">
  <div class="trip-type-tabs mb-4">
    <button type="button" class="trip-tab" [ngClass]="{'active': value === 'local'}" (click)="select('local')">Local</button>
    <button type="button" class="trip-tab" [ngClass]="{'active': value === 'outstation'}" (click)="select('outstation')">Outstation</button>
    <button type="button" class="trip-tab" [ngClass]="{'active': value === 'airport'}" (click)="select('airport')">Airport</button>
  </div>
</div>
